<section class="container">
  @if (!isDataLoading) {
  <mat-list class="nav-bar-list">
    <mat-list-item>
      <div class="menu" (click)="close()">
        <mat-icon matListItemIcon>menu_open</mat-icon>
        <span
          class="close-icon-text"
          i18n="@@NavigationBarCloseSidePanelMenuBtn"
          >Close</span
        >
      </div>
    </mat-list-item>
    <mat-list-item>
      <a [href]="homePageUrl">
        <mat-icon
          matListItemIcon
          class="material-icons-filled"
          matTooltipPosition="right"
          matTooltip="Watch Home"
          matTooltipClass="navigation-tooltip "
          >home
        </mat-icon>
      </a>
    </mat-list-item>
    <mat-list-item>
      <a [href]="selectionToolUrl">
        <mat-icon
          matListItemIcon
          class="material-icons-outlined"
          matTooltipPosition="right"
          matTooltip="Watch Results"
          matTooltipClass="navigation-tooltip"
          i18n-matTooltip="@@NavigationBarWatchResultsTooltip"
          >fact_check
        </mat-icon>
      </a>
    </mat-list-item>
    @if (this.shouldDisplaySharingIcon) {
    <mat-list-item>
      <a [href]="sharedResultsPageUrl">
        <mat-icon
          matListItemIcon
          class="material-icons-outlined"
          matTooltipPosition="right"
          matTooltip="Shared Results"
          matTooltipClass="navigation-tooltip"
          i18n-matTooltip="@@NavigationBarWatchResultsTooltip"
          >share
        </mat-icon>
      </a>
    </mat-list-item>
    }
    <mat-list-item
      routerLinkActive="is-active"
      [routerLink]="['/order-management']"
    >
      <mat-icon
        matListItemIcon
        class="material-icons-outlined"
        matTooltipPosition="right"
        matTooltip="Portfolio Management"
        matTooltipClass="navigation-tooltip"
        i18n-matTooltip="@@NavigationBarWatchResultsTooltip"
        >folder
      </mat-icon>
    </mat-list-item>
  </mat-list>
  }
</section>
